import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";

export const PolylinesRenderer = ({ polygons }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    // Clear previously rendered polygons
    const googlePolygons = [];
    const markers = [];

    // Add polygons to the map
    polygons.forEach(({ coordinates, line_details, num_stations }) => {
      let color = line_details[0].type_line.color;
      if (line_details.length > 1) color = "008080"; // Black for mixed types

      const polygon = new window.google.maps.Polyline({
        path: coordinates,
        map,
        strokeColor: "#" + color,
        strokeWeight: 3,
      });

      googlePolygons.push(polygon);

      // Calculate the midpoint of the polyline
      const midpoint = calculateMidpoint(coordinates);

      // Create a custom icon with a circular background
      const labelText = `${num_stations}`; // Label text (1-based numbering)
      const icon = {
        path: window.google.maps.SymbolPath.CIRCLE,
        fillColor: "#000000", // Background color of the circle
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 12, // Size of the circle
        labelOrigin: new window.google.maps.Point(0, 0), // Center the label
      };

      // Add a marker with the custom icon and label
      const marker = new window.google.maps.Marker({
        position: midpoint,
        map,
        label: {
          text: labelText,
          color: "#ffffff", // White text
          fontSize: "11px",
          fontWeight: "bold",
        },
        icon: icon,
      });

      markers.push(marker);
    });

    // Cleanup function to remove polygons and markers when component unmounts or dependencies change
    return () => {
      googlePolygons.forEach((polygon) => {
        polygon.setMap(null);
        window.google.maps.event.clearInstanceListeners(polygon);
      });
      markers.forEach((marker) => {
        marker.setMap(null);
      });
    };
  }, [map, polygons]);

  return null;
};

// Helper function to calculate the midpoint of a polyline
const calculateMidpoint = (coordinates) => {
  if (coordinates.length === 2) {
    // Calculate the geographic midpoint between two coordinates
    const [coord1, coord2] = coordinates;
    const lat1 = coord1.lat;
    const lng1 = coord1.lng;
    const lat2 = coord2.lat;
    const lng2 = coord2.lng;

    const midLat = (lat1 + lat2) / 2;
    const midLng = (lng1 + lng2) / 2;

    return { lat: midLat, lng: midLng };
  }

  // For polylines with more than two coordinates, use the middle coordinate
  const midIndex = Math.floor(coordinates.length / 2);
  return coordinates[midIndex];
};
